import { setAllWorkspaces, setLogin } from "state/reducers/authReducer";

// login, register, link, increment
export const handleGoogleOnboardResponse = async ({
	code,
	dispatch,
	navigate,
	kind,
}) => {
	const url = `${process.env.REACT_APP_PORT}/google/auth/${kind}`;

	const response = await fetch(url, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({ code }),
	});

    const data = await response.json();

    console.log(data);
    
    if ([200, 201].includes(response.status)) {
        const { user, token } = data;

		// create a simple connection to extension
		window.chrome.runtime?.sendMessage(
			"mfeocjjbgeaghclfnpdjfihpghnchoni",
			{ data: { user, token } }, // MAY NEED TO JSONIFY it
			(response) => console.log(response)
		);

		dispatch(setLogin({ user, token }));
		navigate("/");
	}
};

export const handleGoogleIncrementResponse = async ({
	code,
	token,
	dispatch,
}) => {
	_handleGoogleMoreResponse(code, token, dispatch, "increment");
};

export const handleGoogleLinkResponse = async ({ code, token, dispatch }) => {
	_handleGoogleMoreResponse(code, token, dispatch, "link");
};

const _handleGoogleMoreResponse = async (code, token, dispatch, kind) => {
	const url = `${process.env.REACT_APP_PORT}/google/auth/${kind}`;
	const response = await fetch(url, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({ code }),
	});

	if (response.status === 201) {
		const { allWorkspaces } = await response.json();

		dispatch(
			setAllWorkspaces({
				allWorkspaces,
			})
		);
	}
};
